import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem,
    Box,
    CircularProgress,
    Typography
} from '@mui/material';
import SortIcon from '../../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../../Buttons/SbActionDropdownButton';
import StatusBadgeWithDropdown from '../../Buttons/StatusBadgeWithDropdown';
import { Modal } from 'react-bootstrap';
import runImg from '../../../assets/images/Settings/runImg.svg'
import Swal from 'sweetalert2';

const data = [
    {
        restSourceName: "Customer Master",
        type: 'SAP',
        // synchronized: 'Yes',
        operations: 'Get',
        endPointUrl: 'https://api.sourcea.com',
        paginationType: "No Pagination",
        authentication: 'OAuth 2.0',
        credentials: "KEY:hvghgghggvgv",
        subscribedFrom: '2024-01-15',
        // subscriptionStatus: 'Active',
        // subscribers: 150,
        updated: '2024-02-10',
    },
    {
        restSourceName: "Customer Master",
        type: 'SAP',
        // synchronized: 'No',
        operations: 'Post',
        endPointUrl: 'https://api.sourceb.com',
        paginationType: "Page Size and fetch offset",
        authentication: 'API Key',
        credentials: "KEY:hvghgghggvgv",
        subscribedFrom: '2023-11-20',
        // subscriptionStatus: 'Inactive',
        // subscribers: 85,
        updated: '2024-01-05',
    },
    {
        restSourceName: "Customer Master",
        type: 'SAP',
        // synchronized: 'Yes',
        operations: 'Post',
        endPointUrl: 'https://api.sourcec.com',
        paginationType: "Page Size and Page Number",
        authentication: 'Basic Auth',
        credentials: "KEY:hvghgghggvgv",
        subscribedFrom: '2024-02-01',
        // subscriptionStatus: 'Active',
        // subscribers: 230,
        updated: '2024-02-09',
    },
    {
        restSourceName: "User Master",
        type: 'Oracle',
        // synchronized: 'No',
        operations: 'Get',
        endPointUrl: 'https://api.sourced.com',
        paginationType: "Page Number",
        authentication: 'OAuth 2.0',
        credentials: "KEY:hvghgghggvgv",
        subscribedFrom: '2023-09-12',
        // subscriptionStatus: 'Active',
        // subscribers: 95,
        updated: '2024-02-07',
    },
];


const columns = [
    { id: 'restSourceName', label: 'REST SOURCE NAME', align: 'left', minWidth: '200px', sortable: false },
    { id: 'type', label: 'TYPE', align: 'left', minWidth: '120px', sortable: false },
    // { id: 'synchronized', label: 'SYNCHRONIZED', align: 'left', minWidth: '80px' },
    { id: 'operations', label: 'METHOD', align: 'left', minWidth: '80px', sortable: false },
    { id: 'endPointUrl', label: 'END POINT URL', align: 'left', minWidth: '80px', sortable: false },
    { id: 'paginationType', label: 'PAGINATION TYPE', align: 'left', minWidth: '200px', sortable: false },
    { id: 'authentication', label: 'AUTHENTICATION TYPE', align: 'left', minWidth: '180px', sortable: false },
    { id: 'credentials', label: 'AUTHENTICATION CREDENTIALS', align: 'left', minWidth: '250px', sortable: false },
    { id: 'subscribedFrom', label: 'CREATED ON', align: 'left', minWidth: '150px', sortable: false },
    // { id: 'subscriptionStatus', label: 'SUBSCRIPTION STATUS', align: 'left', minWidth: '180px', sortable: false },
    // { id: 'subscribers', label: 'SUBSCRIBERS', align: 'left', minWidth: '80px', sortable: false },
    { id: 'updated', label: 'UPDATED ON', align: 'left', minWidth: '150px', sortable: false },
    { id: 'synchData', label: 'SYNCH DATA', align: 'left', minWidth: '150px', sortable: false },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const RestDataSourcesTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    const [isSyncing, setIsSyncing] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleSyncDataClick = () => {
        setIsSyncing(true);
        setUploadProgress(0); // Reset progress

        const interval = setInterval(() => {
            setUploadProgress((prevProgress) => {
                if (prevProgress >= 100) {
                    clearInterval(interval);
                    setIsSyncing(false);
                    Swal.fire({
                        title: 'Success',
                        text: '1000 Data uploaded successfully!',
                        icon: 'success',
                        confirmButtonText: 'OK',
                    });
                    return 100; // Ensure it doesn't go above 100
                }
                return prevProgress + 10; // Increment progress by 10%
            });
        }, 1000); // Update progress every second
    };

    return (
        <>
            <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                        {column.label}
                                        {column.sortable !== false && (
                                            <IconButton
                                                size="small"
                                                onClick={(event) => handleRequestSort(event, column.id)}
                                            >
                                                <img src={SortIcon} alt="Sort" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedData.map((customer) => (
                            <TableRow key={customer.id}>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align}>
                                        {column.id === 'synchData' ? (
                                            <img
                                                src={runImg}
                                                alt="Synch Data"
                                                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                                                onClick={handleSyncDataClick}
                                            />
                                        ) : column.id === 'action' ? (
                                            <SbActionDropdownButton
                                                options={[{ type: 'ViewJSON' }]}
                                                viewJsonModal={props.handleOpenResponseModal}
                                            />
                                        ) : (
                                            customer[column.id]
                                        )}
                                    </TableCell>

                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                >
                    <MenuItem onClick={() => handleSortOrderChange('asc')}>
                        <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                        Ascending to Descending
                    </MenuItem>
                    <MenuItem onClick={() => handleSortOrderChange('desc')}>
                        <img src={descToAsc} alt="" />&nbsp;&nbsp;
                        Descending to Ascending
                    </MenuItem>
                </Menu>
            </TableContainer>
            {/* Syncing Modal */}
            <Modal
                show={isSyncing}
                onHide={() => setIsSyncing(false)}
                centered
            >
                <Modal.Body className="data-source-progressbar-modal">
                    <div className="data-source-progressbar">
                        <div className="progress">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: `${uploadProgress}%` }}
                                aria-valuenow={uploadProgress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                {uploadProgress}%
                            </div>
                        </div>
                    </div>
                    <h6 className='m-3'>Connection Established. Data Uploading, please wait...</h6>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default RestDataSourcesTable;
